<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('guide.guidePage')" prop="bannerUrl" >
        <file-upload type="image" :value="form.bannerUrl" :count="1" @change="coverHandle"></file-upload>
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.bannerUrl"-->
<!--          :showUploadList="false"-->
<!-- removed old yourstc upload url -->
<!--          :beforeUpload="beforeUpload"-->
<!--          :customRequest="handleChange"-->
<!--        >-->
<!--          <div v-if="form.bannerUrl" class="upload-image-wrapper">-->
<!--            <img-->
<!--              :src="form.bannerUrl"-->
<!--              alt="logo"-->
<!--              style="height:104px;max-width:300px"/>-->
<!--            <div v-if="uploadLoading" class="upload-mask">-->
<!--              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">{{ $t('guide.upload') }}</div>-->
<!--          </div>-->
<!--        </a-upload>-->
      </a-form-model-item>
<!--      <a-form-model-item label="状态" prop="isBan" >-->
<!--        <a-select v-model="form.isBan" placeholder="请选择" >-->
<!--          <a-select-option :value="false">启用</a-select-option>-->
<!--          <a-select-option :value="true">封禁</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('guide.sort')" prop="sort" >
        <a-input-number style="width: 100%;" v-model="form.sort" :placeholder="$t('guide.inputSort')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPage, addPage, updatePage } from '@/api/guide/page'
import UploadFileToVOD from '@/api/vod.js'
import UploadFileToOSS from "@/utils/upload-file-to-oss";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      uploadLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        sort: null,

        isBan: false,

        bannerUrl: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        sort: [
          { required: true, message: this.$t('guide.sortRequired'), trigger: 'blur' }
        ],
        bannerUrl: [
          { required: true, message: this.$t('guide.bannerUrlRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    coverHandle(val) {
      this.form.bannerUrl = val;
    },
    handleChange(info) {
      const that = this
      that.uploadLoading = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.bannerUrl = fileName[0];//文件名
          that.uploadLoading = false;
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('bannerUrl')
            }
          })
        },
        error: function () {
          that.uploadLoading = false;
          that.$message.error(that.$t('guide.uploadFailed'));
        }
      });
    },
    beforeUpload: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('guide.uploadImage'))
        this.uploadLoading = false
        return false
      }
      this.form.bannerUrl = ''
      this.uploadLoading = true
      // TODO 驗證文件大小
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        sort: null,
        isBan: false,
        bannerUrl: null,
        createTime: null,
        remark: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('guide.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPage({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('guide.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updatePage(this.form).then(response => {
              this.$message.success(
                this.$t('system.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addPage(this.form).then(response => {
              this.$message.success(
                this.$t('system.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.upload-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 4px;
}

.avatar-uploader {
  :deep(.ant-upload-select-picture-card) {
    width: 104px;
    height: 104px;
  }

  :deep(.ant-upload-select-picture-card:hover) {
    border-color: #1890ff;
  }
}
</style>
